module.exports = __webpack_public_path__ + "static/media/app-img.ce743e68.svg";